import React from "react";
import Header from "./landing/Header";
import Hero from "./landing/Hero";
import Features from "./landing/Features";
import Process from "./landing/Process";
import Pricing from "./landing/Pricing";
import Audience from "./landing/Audience";
import Tools from "./landing/Tools";
import Testimonials from "./landing/Testimonials";
import Contact from "./landing/Contact";
import Footer from "./landing/Footer";
import Cta from "./Cta";

export default function Landing() {
  return (
    <>
      <Header />
      <Hero className="font-sans" />
      <Features />
      <Process />
      <Pricing />
      <Audience />
      <Tools />
      {/* <Testimonials /> */}
      <Cta />
      <Contact />
      <Footer />
    </>
  );
}
